import { render, staticRenderFns } from "./Qa.vue?vue&type=template&id=62f7a10a&scoped=true"
import script from "./Qa.vue?vue&type=script&lang=js"
export * from "./Qa.vue?vue&type=script&lang=js"
import style0 from "./Qa.vue?vue&type=style&index=0&id=62f7a10a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62f7a10a",
  null
  
)

export default component.exports